import styled from "styled-components";

const Welcome = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 105px);
  padding: 1.5rem 0 5rem;
  background-color: #ebebeb;
`;

const MainContainer = styled.section`
  width: 1400px;
  @media screen and (max-width: 950px) {
    width: 700px;
  }
  @media screen and (max-width: 550px) {
    width: 330px;
  }
`;

const MainContainer2 = styled.section`
  margin-top: 30px;
  width: 1400px;
  @media screen and (max-width: 950px) {
    width: 700px;
  }
  @media screen and (max-width: 550px) {
    width: 330px;
  }
`;

const Intro = styled.div`
  text-align: center;
  padding: 0 0 2rem;
`;

Intro.Title = styled.h1`
  text-transform: uppercase;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.level3};
`;

Intro.Description = styled.p`
  margin: 1.5rem 0 0.5rem;
  color: ${({ theme }) => theme.colors.dark};
`;

export default { Welcome, Intro, MainContainer, MainContainer2 };
